import { TableBody, TableCell, TableRow } from "@mui/material";
import DynamicTable from "../../../components/tables/dynamicTable";
import { DateProgressBar } from "../../../components/hospitalManagement/dateProgressBar";
import moment from "moment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import routesName from "../../../constants/routesName";
import { useAppDispatch } from "../../../redux/store";
import { getHospitalById, getHospitalByStatus } from "../../../redux/addHospital/hospitalManagementReducer";
import successToast from "../../../utils/successToast";
import errorToast from "../../../utils/errorToast";
import { LoadingSpinner } from "../../../components/ui/loadinSpinner";
import { removeInstalment, removeUnderScore } from "../../../helper";
import StatusWithColor from "../../../utils/StatusWithColor";
import enums from "../../../constants/enums";
import { PrimaryButton } from "../../../components/buttons/buttons";
import ColumnSettingBtn from "../../../components/columnSetting/columnSettingBtn";
import ColumnSetting from "../../../components/columnSetting/columnSetting";
import { TableFilterData } from "../../../modals/Itables";
import useDisplayToggle from "../../../utils/useDisplayToggle";
import ConfirmationModal from "../../../components/modals/confirmationModal";
import DeleteIcon from "../../../assests/icons/deleteIcon.png";
import useAxios from "../../../hooks/useAxios";
import { hospitalApi } from "../../../jsonData/apiPathData/hospital";
import { EditIcon } from "../../../components/muiIconsImport";
import { formatIndianRupee } from "../../../utils/formatIndianRupee";
import { ActionTooltip } from "../../../utils/toolTip";
import { AsyncAccessTokenDecoder } from "../../../utils/accessTokenDecoder";
import axios from "axios";
import dayjs from "dayjs";
const HosPlanInformation = ({ hospitalDetailsRes }: any) => {
  const styles = {
    // borderLeft: "1px solid #F2F4F7",
    borderRight: "1px solid #F2F4F7",
    borderBottom: "1px solid #F2F4F7",
    background: "white",
    minWidth: "150px",
    maxWidth: "150px",
    paddingLeft: "16px",
    paddingRight: "16px",
    color: "#667085",
    fontWeight: 500,
    fontFamily: "Inter, sans-serif",
    height: "70px",
  };
  const currentDate = new Date();

  const params = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [filter, setFilter] = useState<TableFilterData>({});
  const [productId, setProductId] = useState<number>();
  const [action, setAction] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const hospitalId = hospitalDetailsRes?.data?.data?.hospitalId;
  const [clinicalAssitantStatus, setClinicalAssitantStatus] = useState(false);
  const [managmentAssitantStatus, setManagmentAssitantStatus] = useState(false);
  const decodeToken = AsyncAccessTokenDecoder();

  const productAndPlanInfo =
    hospitalDetailsRes?.data?.data?.productandPlanInfos;
  const costDetailsInfo = hospitalDetailsRes?.data?.data?.deviceCost;

  const [moreOption, setMoreOption] = useState<null | number | boolean>(null);
  const [isMoreOption, setisMoreOption] = useState<any>(false);

  const onClickRef = useRef(null);
  const insideClickRef = useRef(null);
  useDisplayToggle({
    onClickRef,
    insideClickRef,
    setDisplay: setisMoreOption,
  });

  useEffect(() => {
    if (isMoreOption === false) {
      setMoreOption(null);
    }
  }, [isMoreOption]);

  const toogle = (index: number) => {
    if (moreOption === index) {
      setisMoreOption(false);
      setMoreOption(null);
    } else {
      setMoreOption(index);
      setisMoreOption(true);
    }
  };

  useEffect(() => {
    // 1. Create/join the sync channel
    const channel = new BroadcastChannel('hospital_update_channel');

    // 2. Listen for messages from the spawned window
    channel.onmessage = (event) => {
      if (event.data === 'HOSPITAL_UPDATED') {
        // 3. Trigger your dispatches reactively!
        dispatch(
          getHospitalByStatus({
            status: (sessionStorage.getItem("hospitalStatus") as string) ?? "allStatus",
            orderBy: '',
            order: '',
            page: 0,
            rowsPerPage: 10,
            searchQuery: "",
            searchKeywords: '',
          })
        );

        if (params?.id) {
          dispatch(getHospitalById(params.id as string));
        }
      }
    };

    // 4. Clean up the channel connection when component unmounts
    return () => {
      channel.close();
    };
  }, [dispatch, params?.id]);

  const editHospitalFn = () => {
    window.open(`${routesName.hospitalManagementPage}/edit-product-plan/${hospitalId}?closeonsave=true`, 'Edit Product Info', 'width=800,height=600');
    // navigate(
    //   `${routesName.hospitalManagementPage}/edit-product-plan/${hospitalId}`
    // );
  };

  // checking for cilincial assistant is active or not
  useEffect(() => {
    const clinicalAssitStatus =
      productAndPlanInfo?.find(
        (item: any) => item?.productInfo?.productId === 1001
      )?.planInfo?.isActive === 1;
    setClinicalAssitantStatus(clinicalAssitStatus);
    const managementAssitStatus =
      productAndPlanInfo?.find(
        (item: any) => item?.productInfo?.productId === 1000
      )?.planInfo?.isActive === 1;
    setManagmentAssitantStatus(managementAssitStatus);
  }, [productAndPlanInfo]);

  const hospitalActiveDeactivateFn = (productId: number, action: string) => {
    if (productId === 1000 && clinicalAssitantStatus) {
      errorToast(
        "You can't deactivate Management Assistant while Clinical Assistant is still active"
      );
    } else if (productId === 1001 && !managmentAssitantStatus) {
      errorToast(
        "You can't activate Clinical Assistant while Management Assistant is deactive"
      );
    } else {
      setProductId(productId);
      setAction(action);
      setIsShowModal(true);
    }
  };
  // activate deactivate product axios call
  const {
    data: activateOrDeactivateSuccess,
    error: activateOrDeactivateError,
    loading: activateOrDeactivateLoading,
    postFn: activateOrDeactivateFn,
    toggle,
  } = useAxios({
    method: "post",
    path: `${hospitalApi.activateOrDeactivate
      }hospitalid=${hospitalId}&productid=${productId}&isactive=${action === "Deactivate" ? 0 : 1
      }`,
  });

  // useEffect(() => {
  //   if (activateOrDeactivateSuccess?.success) {
  //     successToast(activateOrDeactivateSuccess?.message);
  //     dispatch(getHospitalById(hospitalId));
  //   } else if (activateOrDeactivateError) {
  //     errorToast(activateOrDeactivateError?.message ?? "Something Went Wrong");
  //   }
  // }, [activateOrDeactivateSuccess, activateOrDeactivateError, toggle]);
  // useEffect(() => {
  //   const processAfterActivation = async () => {
  //     if (activateOrDeactivateSuccess?.success) {
  //       successToast(activateOrDeactivateSuccess?.message);
  //       if (activateOrDeactivateSuccess?.success && action === "Deactivate") {
  //         // navigate("/dashBoard");

  //         axios.defaults.headers[
  //           "Authorization"
  //         ] = `Bearer ${sessionStorage.getItem('newlogin')}`;

  //         const url = process.env.REACT_APP_MA_LOGIN_NEW_URL || ''; // Replace with actual URL

  //         const headers = {
  //           'accept': '*/*',
  //           'Content-Type': 'application/json;odata.metadata=minimal;odata.streaming=true',
  //         };
  //         const user = sessionStorage.getItem('maLoginCredentials')
  //         const data = {
  //           email: user?.email,     // Replace with actual email
  //           password: user?.password,  // Replace with actual password
  //         };

  //         axios.post(url, data, { headers })
  //           .then(response => {
  //             sessionStorage.setItem(
  //               constants.accessTokenText,
  //               loginData?.userdetails?.accessToken
  //             );
  //             sessionStorage.setItem(constants.isLoginLocalStorage, "true");
  //             sessionStorage.setItem('newlogin', response?.data?.access_token);
  //             sessionStorage.setItem('maLoginCredentials', JSON.stringify(data));
  //             window.location.reload();
  //           })
  //           .catch(error => {
  //             setEmailError("");
  //             setPasswordError("");
  //             console.r('error:', error);
  //             setErrorMessage(error.message);
  //             // window.location.reload();
  //           });

  //       }

  //       // If Management Assistant deactivation API needed
  //       if (hospitalId && action === "Deactivate") {
  //         try {
  //           const url = process.env.REACT_APP_MA_DEACTIVATE_HOSPITAL_URL || "";
  //           const token = sessionStorage.getItem("newlogin");

  //           const headers = {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           };



  //           const maResponse = await axios.get(url, {
  //             headers,
  //             params: { hospitalId }
  //           });
  //           console.log("MA API Response:", maResponse.data);
  //         } catch (err: any) {
  //           console.error("MA API Error:", err);
  //           errorToast("MA Assistant API failed");
  //         }
  //       }

  //       // After everything is done → refresh hospital data
  //       dispatch(getHospitalById(hospitalId));
  //     }

  //     // Handle Errors
  //     else if (activateOrDeactivateError) {
  //       errorToast(activateOrDeactivateError?.message ?? "Something Went Wrong");
  //     }
  //   };

  //   processAfterActivation();
  // }, [
  //   activateOrDeactivateSuccess,
  //   activateOrDeactivateError,
  //   toggle,
  //   productId,
  //   action,
  //   hospitalId,
  //   dispatch,
  // ]);

  useEffect(() => {
    const handleDeactivation = async () => {
      if (!activateOrDeactivateSuccess?.success) return;

      successToast(activateOrDeactivateSuccess?.message);

      // Only proceed when product is Deactivated
      if (action === "Deactivate") {
        try {
          const loginUrl = process.env.REACT_APP_MA_LOGIN_NEW_URL || "";
          const deactivateUrl = process.env.REACT_APP_MA_DEACTIVATE_HOSPITAL_URL || "";




          // 4. Call the MA deactivate API
          if (hospitalId) {
            const maResponse = await axios.get(deactivateUrl, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("newlogin")}`,
                "Content-Type": "application/json",
              },
              params: { hospitalId },
            });
            if (maResponse) {
              // 1. Get stored MA credentials
              const userString = sessionStorage.getItem("maLoginCredentials");
              const user = userString ? JSON.parse(userString) : null;

              const loginBody = {
                email: user?.email,
                password: user?.password,
              };

              // 2. Login to MA and get new token
              const loginResponse = await axios.post(
                loginUrl,
                loginBody,
                {
                  headers: {
                    "Content-Type": "application/json",
                    accept: "*/*",
                  },
                }
              );

              const accessToken = loginResponse?.data?.access_token;

              // 3. Save new token
              sessionStorage.setItem("newlogin", accessToken);
              window.location.reload();
            }
            console.log("MA API Response:", maResponse.data);
          }
        } catch (err: any) {
          console.error("MA API Error:", err);
          errorToast("MA Assistant API failed");
        }
      }

      // 5. Refresh hospital details
      dispatch(getHospitalById(hospitalId));
    };

    handleDeactivation();
  }, [
    activateOrDeactivateSuccess,
    activateOrDeactivateError,
    toggle,
    productId,
    action,
    hospitalId,
    dispatch,
  ]);

  const {
    labelData,
    selectedValuesOrder,
    filterValues,
    initialCHKVal,
    handleCheckboxChange,
    handleCancelFilter,
    handleApplyFilter,
    handleFilterSearch,
  } = ColumnSetting(headerData, checkBoxData);

  const TblBodyProductPlan = ({ labelData, selectedValuesOrder }: any) => {
    const filteredLabelData = labelData?.filter((item: any) =>
      selectedValuesOrder?.includes(item.value)
    );

    return (
      <TableBody>
        {productAndPlanInfo?.map((item: any, index: any) => {
          const validityEnd = item?.planInfo?.validityEnd;
          // console.log(validityEnd, 'validityEnd');
          const isValidityPastOneMonthBeforeExpiry = () => {
            if (!validityEnd) return false;

            const today = dayjs().startOf("day");
            const end = dayjs(validityEnd).startOf("day");
            const diffInDays = end.diff(today, "day");
            // return true only if expiry is within the next 0-30 days
            console.log(diffInDays, 'diffInDays');
            return diffInDays >= 0 && diffInDays <= 31;
          };
          return (
            <React.Fragment key={index}>
              <TableRow key={index}>
                {filteredLabelData?.map((columnValue: any) => {
                  return (
                    <React.Fragment key={`${index}-${columnValue.value}`}>
                      {columnValue.value === "action" && (
                        <TableCell
                          style={{
                            ...styles,
                            minWidth: "80px",
                            maxWidth: "80px",
                            textAlign: "center",
                            left: "0px",
                          }}
                        >
                          <ActionTooltip
                            content={
                              <div
                                className="bg-white absolute left-[-16px] bottom-[-40px] mt-1 ms-12 border z-30 flex flex-col shadow-lg rounded-lg whitespace-nowrap"
                                ref={insideClickRef}
                              >
                                {isValidityPastOneMonthBeforeExpiry() &&
                                  decodeToken?.Roles !== "Admin" ? (
                                  <button
                                    type="button"
                                    className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-t-lg rounded-b-lg"
                                    onClick={() => editHospitalFn()}
                                  >
                                    Renew
                                  </button>
                                ) : (
                                  <>
                                    {item?.planInfo?.isActive === 1 && (
                                      <button
                                        type="button"
                                        className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold  rounded-t-lg"
                                        onClick={() => editHospitalFn()}
                                      >
                                        Edit
                                      </button>
                                    )}
                                    {item?.planInfo?.isActive === 1 && decodeToken?.Roles !== "Admin" && (
                                      <button
                                        type="button"
                                        className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-b-lg ${validityEnd > currentDate && ""
                                          } `}
                                        onClick={() =>
                                          hospitalActiveDeactivateFn(
                                            item?.productInfo?.productId,
                                            "Deactivate"
                                          )
                                        }
                                      >
                                        {activateOrDeactivateLoading ? (
                                          <LoadingSpinner
                                            width="w-4"
                                            height="h-4"
                                          />
                                        ) : (
                                          "Deactivate"
                                        )}
                                      </button>
                                    )}
                                    {item?.planInfo?.isActive === 0 && (
                                      <>
                                        <button
                                          type="button"
                                          className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-t-lg  ${validityEnd > currentDate && ""
                                            } `}
                                          onClick={() => editHospitalFn()}
                                        >
                                          Edit
                                        </button>
                                        {decodeToken?.Roles !== "Admin" && <button
                                          type="button"
                                          className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold  rounded-b-lg ${validityEnd > currentDate && ""
                                            } `}
                                          onClick={() =>
                                            hospitalActiveDeactivateFn(
                                              item?.productInfo?.productId,
                                              "Activate"
                                            )
                                          }
                                        >
                                          Reactivate
                                        </button>}
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            }
                          >
                            <button
                              className="text-blue-300 w-[24px] h-[24px]"
                              type="button"
                              onClick={() => toogle(index)}
                              ref={onClickRef}
                            >
                              <MoreVertIcon />
                            </button>
                          </ActionTooltip>
                        </TableCell>
                      )}
                      {columnValue.value === "products" && (
                        <TableCell style={{ ...styles, minWidth: "250px" }}>
                          <span> {item?.productInfo?.name == "Management Assistant" ? "Buisness Management" : item?.productInfo?.name}</span>
                          <div className="mt-3">
                            {item?.planInfo?.isActive === 1 ? (
                              <StatusWithColor value={enums.active} />
                            ) : (
                              <StatusWithColor value={enums.deactivated} />
                            )}
                          </div>
                        </TableCell>
                      )}
                      {columnValue.value === "add_on_services" && (
                        <TableCell style={{ ...styles, minWidth: "200px" }}>
                          {item?.addOnServices?.length <= 0 && "-"}
                          {item?.addOnServices?.map((ser: any, index: any) => {
                            return (
                              <span key={index}>
                                {ser?.serviceName}
                                {index !== item.addOnServices.length - 1 &&
                                  ", "}
                              </span>
                            );
                          })}
                        </TableCell>
                      )}
                      {columnValue.value === "devices" && (
                        <TableCell
                          style={{
                            ...styles,
                            minWidth: "200px",
                            maxWidth: "200px",
                          }}
                        >
                          {item?.packageDevices?.length > 0
                            ? `Package : ${item?.packageDevices?.length + " "}`
                            : `Package : Nill `}
                          |
                          {item?.paidDevices?.length > 0 ? (
                            <span className="ps-1">
                              <span className="text-blue-300">Paid :</span>{" "}
                              {item?.paidDevices?.length}
                            </span>
                          ) : (
                            <span className="ps-1">
                              <span className="text-blue-300">Paid :</span> Nill
                            </span>
                          )}
                        </TableCell>
                      )}
                      {columnValue.value === "service_type" && (
                        <TableCell style={{ ...styles, minWidth: "250px" }}>
                          <>
                            <span className="font-bold mb-10">
                              {"Paid"}
                            </span>

                          </>

                        </TableCell>
                      )}
                      {columnValue.value === "is_pilot" && (
                        <TableCell style={{ ...styles, minWidth: "250px" }}>
                          <>
                            <span className="font-bold mb-10">
                              {item?.planInfo?.isPilot
                                ? removeUnderScore(item?.planInfo?.isPilot ? "Pilot" : "Expired")
                                : "-"}
                            </span>

                          </>
                          <>
                            {item?.planInfo?.isPilot && <>
                              <DateProgressBar
                                validityStart={
                                  item?.planInfo?.pilotFromDate ?? 0
                                }
                                validityEnd={
                                  item?.planInfo?.pilotToDate ?? 0
                                }
                              />
                              <span className="border-l border-gray-300 ps-2">
                                <span>Exp. Date:</span>
                                <span className="font-semibold text-primary">
                                  {item?.planInfo
                                    ?.pilotToDate
                                    ? moment(
                                      item?.planInfo
                                        ?.pilotToDate
                                    ).format("DD MMM YYYY")
                                    : " -"}
                                </span>
                              </span>
                            </>}
                          </>
                        </TableCell>
                      )}
                      {columnValue.value === "plan_type" && (
                        <TableCell style={styles}>
                          {item?.planInfo?.planType
                            ? removeUnderScore(item?.planInfo?.planType)
                            : "-"}
                        </TableCell>
                      )}
                      {columnValue.value === "patient_type" && (
                        <TableCell style={styles}>
                          {item?.planInfo?.patientType
                            ? removeUnderScore(item?.planInfo?.patientType)
                            : "-"}
                        </TableCell>
                      )}
                      {columnValue.value === "subscription_package" && (
                        <TableCell style={styles}>
                          {item?.planInfo?.subscriptionPackage
                            ? removeUnderScore(item?.planInfo?.subscriptionPackage == 1 ? "Gold" : item?.planInfo?.subscriptionPackage == 2 ? "Silver" : item?.planInfo?.subscriptionPackage == 3 ? "Basic" : "")
                            : "-"}
                        </TableCell>
                      )}
                      {columnValue.value === "price" && (
                        <TableCell style={styles}>
                          {item?.planInfo?.patientType === "all"
                            ? item?.planInfo?.planTotalAmount === 0
                              ? "Free"
                              : formatIndianRupee(
                                item?.planInfo?.planTotalAmount
                              )
                            : item?.planInfo?.patientType === "in_patient"
                              ? item?.planInfo?.inPatientAmount === 0
                                ? "Free"
                                : formatIndianRupee(
                                  item?.planInfo?.inPatientAmount
                                )
                              : item?.planInfo?.patientType === "out_patient"
                                ? item?.planInfo?.outPatientAmount === 0
                                  ? "Free"
                                  : formatIndianRupee(
                                    item?.planInfo?.outPatientAmount
                                  )
                                : "Free"}
                        </TableCell>
                      )}
                      {columnValue.value === "plan_validity" && (
                        <TableCell style={{ ...styles, minWidth: "320px" }}>
                          <div className="flex gap-3 items-center whitespace-nowrap">
                            {/* {item?.planInfo?.planType !== "per_annum" ? (
                              "NA"
                            ) : ( */}
                            <>
                              <DateProgressBar
                                validityStart={item?.planInfo?.validityStart}
                                validityEnd={item?.planInfo?.validityEnd}
                              />
                              <span>
                                Exp. Date:
                                <span className="text-primary font-semibold">
                                  {moment(item?.planInfo?.validityEnd).format(
                                    "DD MMM YYYY"
                                  )}
                                </span>
                              </span>
                            </>
                            {/* )} */}
                          </div>
                        </TableCell>
                      )}
                      {columnValue.value === "trial_period" && (
                        <TableCell style={{ ...styles, minWidth: "320px" }}>
                          <div className="flex gap-3 items-center whitespace-nowrap">

                            {item?.planInfo?.trialFromDate && item?.planInfo?.trialToDate ? <>
                              <DateProgressBar
                                validityStart={item?.planInfo?.trialFromDate}
                                validityEnd={item?.planInfo?.trialToDate}
                              />
                              <span>
                                Exp. Date:
                                <span className="text-primary font-semibold">
                                  {moment(item?.planInfo?.trialToDate).format(
                                    "DD MMM YYYY"
                                  )}
                                </span>
                              </span>
                            </> : <>{"NA"}</>}
                          </div>
                        </TableCell>
                      )}
                      {columnValue.value === "security_deposit" && (
                        <TableCell style={styles}>
                          {formatIndianRupee(costDetailsInfo?.securityDeposit)}
                        </TableCell>
                      )}
                      {columnValue.value === "device_cost" && (
                        <TableCell style={styles}>
                          {formatIndianRupee(
                            costDetailsInfo?.totalPaidDevicesCost
                          )}
                        </TableCell>
                      )}
                      {columnValue.value === "instalments" && (
                        <TableCell style={styles}>
                          {removeInstalment(costDetailsInfo?.instalments)}
                        </TableCell>
                      )}
                      {columnValue.value === "one_time_cost" && (
                        <TableCell style={styles}>
                          {formatIndianRupee(costDetailsInfo?.oneTimeCost)}
                        </TableCell>
                      )}
                    </React.Fragment>
                  );
                })}
              </TableRow>
            </React.Fragment>
          );
        })}
      </TableBody>
    );
  };

  return (
    <>
      <ConfirmationModal
        isVisible={isShowModal}
        onClose={() => {
          setIsShowModal(false);
        }}
        onClick={() => {
          activateOrDeactivateFn();
        }}
        icon={DeleteIcon}
        title={`Are you sure you want to ${action} this plan?`}
        description=""
        actionText={action}
        isLoading={activateOrDeactivateLoading}
      />
      <div className="mt-4">
        <div className="py-5 bg-white shadow-sm1 rounded-lg">
          <div className="flex items-center gap-4 justify-end px-5">
            <ColumnSettingBtn
              filterValues={filterValues}
              initialCHKVal={initialCHKVal}
              handleCheckboxChange={handleCheckboxChange}
              handleCancelFilter={handleCancelFilter}
              handleApplyFilter={handleApplyFilter}
              handleFilterSearch={handleFilterSearch}
            />
            <div>
              <PrimaryButton
                icon={<EditIcon />}
                name="Edit"
                type="button"
                onClick={() => editHospitalFn()}
                padding="py-3 px-12"
              />
            </div>
          </div>

          <div className="pt-4">
            <DynamicTable
              filter={filter}
              setFilter={setFilter}
              columnData={labelData}
              children={
                <TblBodyProductPlan
                  labelData={labelData}
                  selectedValuesOrder={selectedValuesOrder}
                />
              }
              pagination={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HosPlanInformation;

const headerData = [
  {
    label: "Action",
    value: "action",
    sort: false,
    search: false,
  },
  {
    label: "Products",
    value: "products",
    sort: false,
    search: false,
  },
  {
    label: "Add-on Services",
    value: "add_on_services",
    sort: false,
    search: false,
  },
  {
    label: "Devices",
    value: "devices",
    sort: false,
    search: false,
  },
  {
    label: "Service Type",
    value: "service_type",
    sort: false,
    search: false,
  },
  {
    label: "Pilot",
    value: "is_pilot",
    sort: false,
    search: false,
  },
  {
    label: "Plan Type",
    value: "plan_type",
    sort: false,
    search: false,
  },
  {
    label: "Patient Type",
    value: "patient_type",
    sort: false,
    search: false,
  },
  {
    label: "Subscription Package",
    value: "subscription_package",
    sort: false,
    search: false,

  },
  {
    label: "Price",
    value: "price",
    sort: false,
    search: false,
  },
  {
    label: "Plan Validity",
    value: "plan_validity",
    sort: false,
    search: false,
  },
  {
    label: "Trial Period(Gold)",
    value: "trial_period",
    sort: false,
    search: false,
  },
  {
    label: "Security",
    value: "security_deposit",
    sort: false,
    search: false,
  },
  {
    label: "Device Cost",
    value: "device_cost",
    sort: false,
    search: false,
  },
  {
    label: "Instalments",
    value: "instalments",
    sort: false,
    search: false,
  },
  {
    label: "One-time Cost",
    value: "one_time_cost",
    sort: false,
    search: false,
  },
];

export const checkBoxData = [
  {
    label: "Action",
    value: "action",
    display: false,
  },
  {
    label: "Products",
    value: "products",
    display: true,
  },
  {
    label: "Add-on Services",
    value: "add_on_services",
    display: true,
  },
  {
    label: "Devices",
    value: "devices",
    display: true,
  },
  {
    label: "Service Type",
    value: "service_type",
    display: true,
  },
  {
    label: "Pilot",
    value: "is_pilot",
    display: true,
  },
  {
    label: "Plan Type",
    value: "plan_type",
    display: true,
  },
  {
    label: "Patient Type",
    value: "patient_type",
    display: true,
  },
  {
    label: "Subscription Package",
    value: "subscription_package",
    display: true,
  },
  {
    label: "Price",
    value: "price",
    display: true,
  },
  {
    label: "Plan Validity",
    value: "plan_validity",
    display: true,
  },
  {
    label: "Trial Period(Gold)",
    value: "trial_period",
    display: true,
  },
  {
    label: "Security Deposit",
    value: "security_deposit",
    display: true,
  },
  {
    label: "Device Cost",
    value: "device_cost",
    display: true,
  },
  {
    label: "Instalments",
    value: "instalments",
    display: true,
  },
  {
    label: "One-time Cost",
    value: "one_time_cost",
    display: true,
  },
];
